import types from './types'

export default {
  [types.mutations.setInformation] (state, payload) {
    state.information = payload
  },
  [types.mutations.setInformationTimeoutChecker] (state, payload) {
    state.informationTimeoutChecker = payload
  }
}
